import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import '../../styles/popupBundler.scss';
import {
  assign as _assign,
  get as _get,
  forOwn as _forOwn,
  toUpper,
} from 'lodash-es';

const popupStyles = {
  //position: 'fixed !important',
  boxShadow: '0 5px 30px rgba(0, 0, 0, 0.04)',
  border: '0px',
  padding: '30px',
  maxWidth: '720px',
  maxHeight: '680px',
  width: '60%',
};

const overlayStyle = {
  background: 'rgba(0, 0, 0, 0.75)',
};

const optionData = _get(
  window,
  'compatioConfig.compatibleProducts.optionsData'
);
const OptionsPopup = ({
  backingProducts,
  optionsDetails,
  setOptionsDetails,
  isOpen,
  bundlerType,
  addfromOutfit,
  toggleBundler,
  parentProduct,
  handleAdd,
  OpenPopReels,
}) => {
  let defaultSelection = {};
  optionData.forEach(element => {
    defaultSelection[element.optionId] = element.options[0].value;
  });
  const [selectedOptions, setSelectedOption] = useState(defaultSelection);

  const [CheckOptionifSelect, setcheckOptionifSelect] = useState(false);

  const currentOptions = { ...selectedOptions };
  let currentBacking = optionsDetails.backingProduct;

  const handleOptionChange = e => {
    currentOptions[`${e.target.name}`] = e.target.value;
    if (currentOptions.backing_option !== 'No Backing') {
      if (
        optionsDetails.details.backing_option !== currentOptions.backing_option
      ) {
        currentBacking = backingProducts.find(
          item => item.name === currentOptions.backing_option
        ).variantId;
      }
    } else {
      currentBacking = ' ';
    }

    setSelectedOption(currentOptions);
    setOptionsDetails({
      show: true,
      details: currentOptions,
      backingProduct: currentBacking,
    });
    setcheckOptionifSelect(true);
  };

  const addOptionsWithProduct = () => {
    if (CheckOptionifSelect == false) {
      setSelectedOption(currentOptions);
      setOptionsDetails({
        show: true,
        details: currentOptions,
        backingProduct: currentBacking,
      });
    }
    if (!addfromOutfit) handleAdd(parentProduct);
    // console.log(parentProduct, 'parentProduct');
    if (
      selectedOptions.backing_option &&
      selectedOptions.backing_option != 'No Backing'
    ) {
      const backing = backingProducts.find(
        each => toUpper(each.name) === toUpper(selectedOptions.backing_option)
      );
      handleAdd(backing.productDetails);
      // console.log(backing.productDetails, 'backing.productDetails');
    }
    toggleBundler();
  };

  const OptionData = (
    <div className="xrs-options">
      <label style={{ fontSize: '14px!important' }}>
        Please confirm these options:
      </label>
      {optionData.map(singleOption => {
        if (singleOption.optionType === 'radio')
          return (
            <div key={singleOption.optionId} className="xcs-option-lable">
              <label>
                <strong>{singleOption.optionDescription}</strong>
              </label>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {singleOption.options.map(ol => {
                  return (
                    <label key={ol.label}>
                      <input
                        type="radio"
                        name={singleOption.optionId}
                        value={ol.value}
                        checked={
                          selectedOptions[singleOption.optionId] === ol.value
                        }
                        onChange={handleOptionChange}
                      />
                      {ol.label}
                    </label>
                  );
                })}
              </div>
            </div>
          );
        if (singleOption.optionType === 'dropdown')
          return (
            <div key={singleOption.optionId} className="xcs-option-lable">
              <label>
                <strong>{singleOption.optionDescription}</strong>
              </label>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {singleOption.options.length > 1 ? (
                  <select
                    value={singleOption.options[0]}
                    onChange={handleOptionChange}
                    name={singleOption.optionId}
                  >
                    {singleOption.options.map(variantOption => (
                      <option
                        id={variantOption.value}
                        value={variantOption.value}
                        key={variantOption.value}
                        className="xrs-product__option-text"
                      >
                        {variantOption.value}
                      </option>
                    ))}
                  </select>
                ) : null}
              </div>
            </div>
          );
      })}
      <span className="Option-pop-button-bottom">
        {/* <a
          className="dc-popoption-back"
          onClick={() => {
            toggleBundler();
          }}
        >
          Cancel
        </a> */}
        <a
          className={
            OpenPopReels
              ? 'dc-options-button addoutfittocartset'
              : 'dc-options-button'
          }
          onClick={() => addOptionsWithProduct()}
        >
          Add to Outfit
        </a>
      </span>
    </div>
  );

  return (
    <div className="dc-product-card--add-to-outfit">
      <Popup
        open={isOpen}
        modal
        position="top center"
        closeOnDocumentClick={false}
        closeOnEscape={false}
        contentStyle={popupStyles}
        overlayStyle={overlayStyle}
        className={bundlerType === 'reelsoptions' ? 'popup-xrs' : ''}
      >
        {close => (
          <div>
            <div style={{ display: 'flex' }} data-testid="productname">
              <h3>{parentProduct ? parentProduct.productName : ''}</h3>
            </div>
            <div style={{ display: 'flex' }}>
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
                className="xcs-option-img imgxcs"
              >
                <img
                  src={
                    parentProduct
                      ? parentProduct.productImage === undefined
                        ? parentProduct.url_image
                        : parentProduct.productImage
                      : ''
                  }
                  // Ensure HTML encoded entities display properly
                  alt={parentProduct ? parentProduct.variantName : ''}
                  className="xrs-product__image"
                  width="150px"
                  height="150px"
                />
              </div>
              {OptionData}
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default OptionsPopup;
